<template>
    <div class="todo">
        <Header :code="code">{{this.projet.nom}}</Header>
        <div class="expanse" v-for="lead in leadsTodo" :key="lead.code_lead">
            <Lead :lead="lead" :code="code" :mode="'lead'" @reloadLeads="reloadLeads" @qualifiedLead="qualifiedLead"/> 
        </div>
        <div v-if='$store.getters.leadsTodo.length == 0' class="mt-6 text-center">
            Vous n'avez pas de taches en cours
        </div>
        <v-dialog
            v-model="dialog"
            >
                <v-card>
                    <v-card-title class="headline">RDV qualifié !</v-card-title>
                        <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                            color="primary"
                            depressed
                            @click="dialog = false"
                        >
                            OK
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        <Footer01 :code="code"/>
    </div>
</template>
<script>
import Header from '@/components/Header'
import Footer01 from '@/components/Footer01'
import Lead from '@/components/Lead'
import { mapGetters } from 'vuex'
import dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat';
export default {
    name: 'Todo',
    props: ['code'],
    components: {
        Header,
        Lead,
        Footer01
    },
    data() {
        return {
            projet: {},
            leadsTodo: {},
            dialog:false,
        }
    },
    methods: {
        reloadLeads: function(){
            console.log('reloadLeads')
            this.leadsTodo = this.$store.getters.leadsTodo
        },
        qualifiedLead: function(){
            this.dialog = true
        }
    },
    computed: {
        // leadsTodo: function(){
        //     return this.$store.getters.leadsTodo
        // }
    },
    watch: {
        
    },
    created() {
        OneSignal.push(function() {
            OneSignal.isPushNotificationsEnabled(function(isEnabled) {
                if (isEnabled)
                console.log("Push notifications are enabled!");
                else
                console.log("Push notifications are not enabled yet.");    
                OneSignal.showNativePrompt();
            });
        });
        if(Object.keys(this.$store.state.leads).length === 0) {
            this.$store.dispatch('setLoader', true).then((e) => {
                this.$store.dispatch('getLeadProjets', {codeProjet: this.code}).then((e)=> {
                    this.$store.dispatch('setLoader', false)
                    this.leadsTodo = Object.assign({}, this.$store.getters.leadsTodo)
                    let projects = this.$store.state.projets
                    this.projet = projects.find((e) => {
                        return e.code_projet == this.code
                    })
                })
            })
        } else {
            this.$store.dispatch('setLoader', false)
            this.leadsTodo = Object.assign({}, this.$store.getters.leadsTodo),
            this.projet = this.$store.state.projets.find((e) => {
                return e.code_projet == this.code
            })
        }
    },
}
</script>
<style lang="scss">
    .todo {
        padding-top:8vh;
        padding-bottom:8vh;
        .expanse {
            margin-top:5px;
        }
        
        
    }
</style>